import {react} from 'react';


export default function contact(){
    return (
      <div className='contact'>
        <h1>Contact</h1>
        <p>Feel Free to Contact <span>daniel.cx.chen@outlook.com</span></p>
      </div>
    )
}